"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grid = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Grid = function Grid(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      width: props.width,
      height: props.height,
      viewBox: "0 0 105 105",
      fill: props.color,
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "12.5",
      cy: "12.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "0s",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "12.5",
      cy: "52.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "100ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "52.5",
      cy: "12.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "300ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "52.5",
      cy: "52.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "600ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "92.5",
      cy: "12.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "800ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "92.5",
      cy: "52.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "400ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "12.5",
      cy: "92.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "700ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "52.5",
      cy: "92.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "500ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      cx: "92.5",
      cy: "92.5",
      r: props.radius
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "fill-opacity",
      begin: "200ms",
      dur: "1s",
      values: "1;.2;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })))
  );
};

exports.Grid = Grid;
Grid.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  radius: _propTypes["default"].number
};
Grid.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  radius: 12.5,
  label: "audio-loading"
};